<div class="md:tw-min-w-[770px] sm:tw-w-[500px] tw-w-[350px]">
  <!-- title -->
  <ng-container *ngIf="isShowDialogTitle">
    <app-modal-title [isShowClose]="true" (isCloseModal)="onClose()">
      <span header-content class="tw-text-base tw-font-normal">
        * <span [innerHTML]="'messages.chooseItem' | translate"></span>
      </span>
    </app-modal-title>
  </ng-container>

  <div mat-dialog-content class="dialog-content">
    <app-ready-templates (selectedReadyTemplate)="onSelect($event)"[isModalMode]="true"> </app-ready-templates>
  </div>
</div>
